import React from 'react'

import IconSun from "./IconSun"
import IconMoon from "./IconMoon"


const ThemeToggle = () => {

    function toggle() {
        window.document.body.classList.toggle('mode-dark')
    }

    return (
        <div className="flex items-center">
            <button aria-label="Colour Theme Button" onClick={toggle} className="focus:outline-none focus:border-transparent focus:shadow-none">
                <IconSun />
                <IconMoon />
            </button>
        </div>
    )
}

export default ThemeToggle
